import { ca } from '@cian/analytics';
import { EObjectType, TFilters } from '@cian/countryside-genplan-component';

export const trackGeplanShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'show',
    label: 'interactive_map',
    useLastProducts: true,
  });
};

export const trackObjectClick = (villageId: number, objectType: EObjectType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'click',
    label: 'object_polygon',
    products: [
      {
        id: villageId,
        offerType: 'KP',
        position: 1,
        extra: {
          object_type: objectType,
        },
      },
    ],
  });
};

export const trackPhoneShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'open',
    label: 'phone_number',
    useLastProducts: true,
  });
};

export const trackPreviewClick = (villageId: number, offerId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'to_card',
    label: 'card_detail_in_new_list',
    products: [
      {
        id: villageId,
        offerType: 'KP',
        position: 1,
        extra: {
          offer_id: offerId,
        },
      },
    ],
  });
};

export const trackFullscreenOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'open',
    label: 'fullscreen',
    useLastProducts: true,
  });
};

export const trackFiltersChange = (villageId: number, filters: TFilters) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'click',
    label: 'filter',
    products: [
      {
        id: villageId,
        offerType: 'KP',
        position: 1,
        extra: {
          filter_state: filters,
        },
      },
    ],
  });
};
